import style from "./home_area.module.css";
import InputText from "@/components/UI/input/input_text";
import { Fragment, useState, useEffect, useContext } from "react";
// import { useRouter } from "next/router";
// import CustomerContext from "@/stores/customer-context";
import Image from "next/image";
import { Popover } from "@headlessui/react";

export default function HomeArea({ values, onChange, errors, touched }) {
  const [sqmSum, setSqmSum] = useState(0);
  const [sqm, setSqm] = useState(0);
  const [extraSqm, setExtraSqm] = useState(0);

  useEffect(() => {
    const subSqm = values.homeSqm + values.homeExtraSqm;
    setSqm(values.homeSqm);
    setExtraSqm(values.homeExtraSqm);
    setSqmSum(subSqm);
  }, [values.homeSqm, values.homeExtraSqm]);

  return (
    <Fragment>
      <div className={style.home_area_info_wrapper}>
        <Popover className={style.home_area_info}>
          <Popover.Button>
            <Image
              src="/assets/icon-svg/icon-tooltip-btn.svg"
              width={16}
              height={16}
              priority={true}
            />
          </Popover.Button>
          <Popover.Panel className={style.home_area_popover}>
            <Image
              src="/assets/icon-svg/graphic-calc-2.svg"
              width={103}
              height={88}
              priority={true}
            />
            <p>คำนวณจากขนาดพื้นที่ กว้างxยาวxจำนวนชั้น ของตัวบ้าน</p>
          </Popover.Panel>
        </Popover>
      </div>
      <div className={style.input_field}>
        <InputText
          name="homeSqm"
          type="number"
          theme="black"
          title="พื้นที่ใช้สอย (เฉพาะตัวบ้านรวมทุกชั้น ไม่รวมที่ดิน)"
          placeholder="0"
          initValue={values.homeSqm}
          onChange={(el) => {
            onChange(el);
          }}
          errorMsg={errors.homeSqm && touched.homeSqm ? errors.homeSqm : ""}
        />
      </div>
      <div className={style.input_field}>
        <InputText
          name="homeExtraSqm"
          type="number"
          theme="black"
          title="พื้นที่ต่อเติม"
          placeholder="0"
          initValue={values.homeExtraSqm}
          onChange={(el) => {
            onChange(el);
          }}
          errorMsg={
            errors.homeExtraSqm && touched.homeExtraSqm
              ? errors.homeExtraSqm
              : ""
          }
        />
      </div>
    </Fragment>
  );
}
